import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from 'redux-saga';
import thunkMiddleware from 'redux-thunk';

// eslint-disable-next-line import/extensions
import { signalrMiddleware } from '../middlewares/signalr.middleware';
import { rootReducer } from '../reducers/root.reducer';
import { createReduxHistory, routerMiddleware } from '../routes/reduxHistory';
import { runSaga } from '../sagas';

const sagaMiddleware = createSagaMiddleware();

const middleware = [routerMiddleware, sagaMiddleware, thunkMiddleware, signalrMiddleware];

export const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(...middleware)));

export const history = createReduxHistory(store);

runSaga(sagaMiddleware);

if (process.env.NODE_ENV === 'development') {
  // @ts-ignore
  global._store_ = store;
}
